module.exports = __webpack_public_path__ + "static/img/why-4.24bccb16.jpg";